import { createContext, useContext } from 'react';

import { AverageColorProps, CellColorProps } from './colouredCells';

export interface MarkbookCellContextValue {
  showPercentage?: boolean;
  getAssessmentEntryColor?: (cellProps: CellColorProps) => string | null;
  getAverageCellColor?: (cellProps: AverageColorProps) => string | null;
}

export const MarkbookCellContext = createContext<MarkbookCellContextValue>({});

export const useMarkbookCellContext = () => {
  const context = useContext(MarkbookCellContext);
  return context;
};
